import { styled } from "@mui/material/styles";
import { getStatusToneStyles, STATUS_PILL_BASE_SX } from "./statusPillTokens";

export const StatusPillRoot = styled("span", {
  shouldForwardProp: (prop) => prop !== "$tone",
})(({ $tone }) => ({
  ...STATUS_PILL_BASE_SX,
  ...getStatusToneStyles($tone),
}));
